// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__wcCnJ","error":"Textarea_error__3cMlQ","readonly":"Textarea_readonly__3_LFM","disabled":"Textarea_disabled__356Kf"};